// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Fem9","header":"ReportDetails_header__3XZWr","title":"ReportDetails_title__1kIQK","left":"ReportDetails_left__3WcMy"};